<template>
  <div id="train">
    <div id="Return_Bar" v-if="$route.query.tabIndex">
      <i class="el-icon-arrow-left"></i>
      <div @click="isreturn" class="isreturn">返回</div>
    </div>
    <div class="video-box" style="padding-left:20px;">
      <div style="width:100%; height:42px; background-color: #DDDDDD;line-height:36px;font-size:16px;padding-left:10px;">
        请认真选择，系统会根据你选择的结果来匹配，准确率越高任务录取率越高，如存在弄虚作假的情况，平台将做永久封禁处理。
      </div>
      <el-form :inline="true">
        <!--用个700，把下面的checkBox,radio框住，免得其自动换行-->
        <el-form-item style="width:700px;">
          <el-link type="info" :underline="false">1、选择自己的在线经验【多选】</el-link>
          <el-tree
                  style="width:500px;"
                  :data="experience.list"
                  :props="props"
                  :default-checked-keys="experience.defaultCheckedArr"
                  node-key="operationTagId"
                  show-checkbox
                  ref="tree"
                  @check="checkChildrenChecked"
                  :check-strictly="true"
                  :default-expand-all="false">

              <span class="aaa" style="height:27px;line-height:26px;width:100%;border: 1px solid #D3D6DB; " slot-scope="{ node, data }">
                <span style="width:100%;">
                  <span style="width:200px; margin-left:10px">{{ node.label.operationTagName }}</span>
                </span>
              </span>
          </el-tree>

          <!--=======================2、选择自己的意向班次【多选】========================experience.intent_serve_hour.list-->
          <el-link type="info" :underline="false" style="margin-top:20px">2、选择自己的意向班次【多选】</el-link>
          <el-checkbox-group v-model="intent_schedule_hour.defaultCheckedArr" style="width:500px;margin-left:44px;">
            <el-checkbox v-for="m in intent_schedule_hour.list" :label="m.operationTagId" :key="m.operationTagId" class="radioOrCheckedBox">
              <div style="margin:5px 0px 0px 10px">{{m.operationTagName}}</div>
            </el-checkbox>
          </el-checkbox-group>

          <!--=======================3、选择自己的意向班次【多选】========================-->
          <el-link type="info" :underline="false" style="margin-top:20px;">3、选择自己期望每天服务的时长【单选】</el-link>
          <el-radio-group v-model="intent_serve_hour.value" style="width:500px;margin-left:44px;">
            <el-radio v-for="m in intent_serve_hour.list" :key="m.operationTagId" :label="m.operationTagId"  class="radioOrCheckedBox" style="line-height:26px;">{{m.operationTagName}}</el-radio>
          </el-radio-group>

          <div style="width:100%;margin-top:20px;">
            <el-button type="primary" size="small" style="margin-left:26px;" @click="isreturn" v-if="$route.query.tabIndex">取消</el-button>
            <el-button type="primary" size="small" @click="saveLabel">保存</el-button>
          </div>
          <br>


        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                experience : {
                    list : [],
                    defaultCheckedArr:[]
                },
                intent_schedule_hour : {
                    list : [],
                    defaultCheckedArr:[]
                },
                intent_serve_hour : {
                    list : [],
                    value : null
                },
                props: {
                    label : function(data, node){
                        return data;
                    }
                }
            }
        },
        components: {

        },
        created() {
            this.queryLabelsByTjkId();

        },
        methods: {
            queryLabelsByTjkId() {
                var self = this;
                var param = '?functionNames=experience_label,intent_schedule_hour_label,intent_serve_hour_label'
                this.$http.post(API_ROOT.tjk + '/operationTagItem/queryTagsByTopFunctionName' + param, {}).then(res=> {
                    var result = res.data;
                    if(result.success) {
                        self.experience.list = result.data.data.experience;
                        self.intent_schedule_hour.list = result.data.data.intent_schedule_hour;
                        self.intent_serve_hour.list = result.data.data.intent_serve_hour;
                        // //把勾选过的，弄出来
                        var checkArr = result.data.mapDefaultChecked;
                        self.experience.defaultCheckedArr = checkArr.labelExpAndIndustryList;
                        self.intent_schedule_hour.defaultCheckedArr = !!checkArr.intent_schedule_hour ? checkArr.intent_schedule_hour : [];
                        self.intent_serve_hour.value = !!checkArr.intent_serve_hour && checkArr.intent_serve_hour.length>0 ? checkArr.intent_serve_hour[0] : null;
                    }else {
                        this.$alert(result.msg);
                    }
                },res=> {
                    this.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
                })
            },
            //返回课程
            saveLabel() {
                var self = this;
                // var checkedNodes = this.$refs.tree.getCheckedNodes();
                var checkedKeys = this.$refs.tree.getCheckedKeys();
                if(checkedKeys && checkedKeys.length>=14){
                    this.$message({ message: '请按照实际情况选择，不要选择过多（通常10个以下）', type: 'warning', center: true, duration: 3000})
                    return;
                }
                //组装店铺和行业
                var data = {
                    // experience_industry : checkedNodes,
                    experience_industry_tagIds : checkedKeys,
                    intent_schedule_hour : this.intent_schedule_hour.defaultCheckedArr,
                    intent_serve_hour : this.intent_serve_hour.value
                }

                var checked_no_exp = null;
                var checked_has_exp = null;
                var checkNodes = this.$refs.tree.getCheckedNodes();
                for(var i = 0; i < checkNodes.length; i++){
                  if(checkNodes[i].operationTagName == '无在线经验'){
                      checked_no_exp = true;
                  }else{
                      checked_has_exp = true;
                  }
                }
                if(checked_no_exp  == true && checked_has_exp == true){
                    this.$message({ message: '不能同时选择【无在线经验】和其他店铺经验', type: 'warning', center: true, duration: 2500})
                    return;
                }

                this.$http.post(API_ROOT.tjk + '/expTjk/saveLabelTjk', data).then(res=> {
                    var result = res.data;
                    if(result.success) {
                        this.$message({ message: '保存成功', type: 'success', center: true, duration: 1500})

                        //--------------------保存课程学习记录--------------------
                        if(!!self.$route.query.tabIndex){
                            this.$http.post(API_ROOT.college + '/courseRecord/tool/addCourseRecord?courseId=' + this.$route.query.courseId, {}).then(res=> {
                                this.isreturn();
                            },res=> {
                                this.$alert("AJAX请求接口异常（/courseRecord/tool/addCourseRecord）！");
                            })
                        }
                        //--------------------保存课程学习记录完毕--------------------

                    }else {
                        this.$message({ message: '操作失败：' + result.msg, type: 'warning', center: true, duration: 2500})
                    }
                },res=> {
                    this.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
                })
            },
            checkChildrenChecked(data, node){
                var _this = this
                // 获取当前节点是否被选中
                const isChecked = this.$refs.tree.getNode(data).checked
                if(isChecked){
                    // 判断是否有上级节点，如果有那么遍历设置上级节点选中
                    data.parentId && _this.setParentChecked(data.parentId, true)
                    // 判断该节点是否有下级节点，如果有那么遍历设置下级节点为选中
                    data.children && _this.setChildreChecked(data.children,true)
                }else{
                    // 判断是否有上级节点，如果有那么遍历设置上级节点选中
                    data.parentId && _this.setParentChecked(data.parentId, false)
                    // 如果节点取消选中，则取消该节点下的子节点选中
                    data.children && _this.setChildreChecked(data.children,false)
                }
            },

            setParentChecked(parentId, isChecked){
                var _this = this;
              // 获取该id的父级node
              const parentNode = _this.$refs.tree.getNode(parentId)
              // 如果该id的父级node存在父级id则继续遍历
              if(isChecked){
                  _this.$refs.tree.setChecked(parentId, true);
                  if(parentNode && parentNode.data && parentNode.data.parentId){
                      _this.setParentChecked(parentNode.data.parentId, true);
                  }
              }else{
                  //查所选节点的父级node,根据是否还有已勾选的子节点，从而设置状态（递归搞）
                  var existChecked = false;
                  if(parentNode == null){
                      return;
                  }
                  for(var i = 0; i<parentNode.childNodes.length; i++){
                      if(parentNode.childNodes[i].checked == true){
                          existChecked = true;
                          break;
                      }
                  }

                  //如果是勾选(取消)，则根据父节点的子节点是否勾选，来遍历的对父节点(勾选,取消)
                  _this.$refs.tree.setChecked(parentId, existChecked);
                  if(parentNode && parentNode.data && parentNode.data.parentId){
                      setParentChecked(parentNode.data.parentId, existChecked);
                  }
              }
          },
            setChildreChecked (node, isChecked){
              var _this = this;
              node.forEach(item => {
                  item.children && _this.setChildreChecked(item.children, isChecked)
                  _this.$refs.tree.setChecked(item.operationTagId,isChecked)
              })
            },
            isreturn(){
                var tabIndex = this.$route.query.tabIndex;
                // tabIndex设置
                //设置不刷到默认位置，直接跳到fbt培训那里
                localStorage.setItem('tabIndex', tabIndex);
                this.$router.push({
                    path:'/train/index'
                })
            }
        }
    }
</script>

<style scoped>
  .isreturn{color:#000;cursor: pointer;}
  /deep/.el-icon-arrow-left{color: #000;}

  #Return_Bar {
    padding-left: 21px;
    display: flex;
    padding-top: 10px;
    padding-bottom: 15px;
    width: 100%;
  }
  /deep/.el-icon-arrow-left {
    margin-top: 5px;
  }

.radioOrCheckedBox{
  height:30px;border:1px solid #ddd;width:455px;padding-left:15px;
}
</style>


// WEBPACK FOOTER //
// ./src/page/train/fbtExperienceChoose.vue